export const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

// Derive WebSocket URL from current page protocol and host so it routes through nginx proxy
// Handle test environment where window is not defined
const _wsProtocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const _wsHost = typeof window !== 'undefined' ? window.location.host : 'localhost:8000';
export const WS_URL = import.meta.env.VITE_WS_URL || `${_wsProtocol}//${_wsHost}`;

// Feature flag: when enabled, audio chunks are sent as binary WebSocket frames
// (raw PCM16 ArrayBuffer) instead of base64-encoded JSON, reducing bandwidth
// by ~33% and eliminating per-chunk base64/JSON overhead. Control messages
// (consent_handshake, is_final) are always sent as JSON text regardless.
export const ENABLE_BINARY_AUDIO_TRANSPORT =
  import.meta.env.VITE_ENABLE_BINARY_AUDIO_TRANSPORT === 'true';